import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { Overlay } from './overlay.js';

var styles = {
raw: ".hcr-popup-1-6-0{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1100}.hcr-popup--active-1-6-0{display:block}.hcr-popup__body-1-6-0{position:fixed;top:50%;left:50%;width:330px;max-width:100%;max-height:100%;padding:36px;-webkit-transform:translateY(-50%) translateX(-50%);transform:translateY(-50%) translateX(-50%);border-radius:5px;background:#fff;font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;font-weight:300;line-height:1.375em;text-align:center;z-index:1101;overflow-y:auto}@media (min-width:600px){.hcr-popup__body-1-6-0{width:600px;padding:36px}}.hcr-popup__icon-1-6-0{padding-bottom:12px}.hcr-popup__title-1-6-0{margin:0;padding-bottom:12px;color:#444;font-size:28px;font-weight:700;line-height:34px}.hcr-popup__content-1-6-0{padding-bottom:12px}.hcr-popup__actions-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-webkit-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}@media (min-width:600px){.hcr-popup__actions-1-6-0 .hcr-btn-1-6-0+.hcr-btn-1-6-0{margin-right:12px;margin-left:0}}",
map:{"hcr-popup":"hcr-popup-1-6-0","hcr-popup--active":"hcr-popup--active-1-6-0","hcr-popup__body":"hcr-popup__body-1-6-0","hcr-popup__icon":"hcr-popup__icon-1-6-0","hcr-popup__title":"hcr-popup__title-1-6-0","hcr-popup__content":"hcr-popup__content-1-6-0","hcr-popup__actions":"hcr-popup__actions-1-6-0","hcr-btn":"hcr-btn-1-6-0"}};

var bem = Bem('popup', styles);
var Popup = function Popup(_ref) {
  var active = _ref.active,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      onOverlayClick = _ref.onOverlayClick,
      rest = _objectWithoutProperties(_ref, ["active", "children", "extraClasses", "onOverlayClick"]);

  return React.createElement("div", _extends({
    className: bem.b({
      active: active
    }, extraClasses)
  }, rest), React.createElement("div", {
    className: bem.e('body')
  }, children), React.createElement(Overlay, {
    extraClasses: Bem('overlay').b(),
    onClick: onOverlayClick
  }));
};
Popup.displayName = 'Popup';
Popup.defaultProps = {
  active: false,
  extraClasses: '',
  onOverlayClick: null
};
Popup.propTypes = {
  /** Whether Popup is visible or not */
  active: PropTypes.bool,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children */
  children: PropTypes.node.isRequired,

  /** custom overlay click handler */
  onOverlayClick: PropTypes.func
};
var popup = Injecss(Popup, styles);

var bem$1 = Bem('popup', styles);
var PopupSection = function PopupSection(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "children", "type"]);

  return React.createElement("div", _extends({
    className: "".concat(bem$1.e(type), " ").concat(extraClasses)
  }, rest), children);
};
PopupSection.defaultProps = {
  type: 'content',
  extraClasses: ''
};
PopupSection.propTypes = {
  /** Of which type the section should be */
  type: PropTypes.oneOf(['title', 'icon', 'content', 'actions']),

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children */
  children: PropTypes.node.isRequired
};

export { popup as Popup, PopupSection };
